export default __webpack_public_path__ + "static/media/burger.e82ddc64.svg";